import { render, staticRenderFns } from "./Territoryrules.vue?vue&type=template&id=088bba36&"
import script from "./Territoryrules.vue?vue&type=script&lang=js&"
export * from "./Territoryrules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports